import React from "react";

export const StarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none">
      <path
        d="M11.9998 17.775L7.84984 20.275C7.66651 20.3916 7.47484 20.4416 7.27484 20.4249C7.07484 20.4083 6.89984 20.3416 6.74984 20.225C6.59984 20.1083 6.48317 19.9626 6.39984 19.788C6.31651 19.6133 6.29984 19.4173 6.34984 19.2L7.44984 14.475L3.77484 11.3C3.60817 11.15 3.50417 10.979 3.46284 10.787C3.42151 10.595 3.43384 10.4076 3.49984 10.225C3.56584 10.0423 3.66584 9.89228 3.79984 9.77495C3.93384 9.65762 4.11717 9.58262 4.34984 9.54995L9.19984 9.12495L11.0748 4.67495C11.1582 4.47495 11.2875 4.32495 11.4628 4.22495C11.6382 4.12495 11.8172 4.07495 11.9998 4.07495C12.1825 4.07495 12.3615 4.12495 12.5368 4.22495C12.7122 4.32495 12.8415 4.47495 12.9248 4.67495L14.7998 9.12495L19.6498 9.54995C19.8832 9.58328 20.0665 9.65828 20.1998 9.77495C20.3332 9.89162 20.4332 10.0416 20.4998 10.225C20.5665 10.4083 20.5792 10.596 20.5378 10.788C20.4965 10.98 20.3922 11.1506 20.2248 11.3L16.5498 14.475L17.6498 19.2C17.6998 19.4166 17.6832 19.6126 17.5998 19.788C17.5165 19.9633 17.3998 20.109 17.2498 20.225C17.0998 20.341 16.9248 20.4076 16.7248 20.4249C16.5248 20.4423 16.3332 20.3923 16.1498 20.275L11.9998 17.775Z"
        fill="#ABCDEC"
      />
    </svg>
  );
};
